import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MessageCircle } from 'lucide-react';

export const WhatsAppButton = () => {
  const { language } = useLanguage();

  return (
    <a
      href="https://wa.me/966599385282"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#C5A059] text-white px-5 py-4 rounded-full shadow-[0_4px_14px_0_rgba(197,160,89,0.5)] hover:shadow-[0_6px_20px_rgba(197,160,89,0.4)] hover:-translate-y-1 transition-all duration-300 group"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="font-manrope text-sm font-medium hidden sm:block">
        {language === 'en' ? 'WhatsApp' : 'واتساب'}
      </span>
    </a>
  );
};
